module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"PDF-LISTEN","lists":"Listen","system":"System","support_link":"Support","logout":"Abmeldung"},"en":{"title":"PDF-Lists","lists":"Lists","system":"System","support_link":"Support","logout":"Logout"}}')
  delete Component.options._Ctor
}
